module.exports = __webpack_public_path__ + "img/th_Crusher_Dust.e177899b.jpg";